import { render } from "./FloatingButtonFormBuilder.vue?vue&type=template&id=35c39f2d&scoped=true"
import script from "./FloatingButtonFormBuilder.vue?vue&type=script&lang=ts"
export * from "./FloatingButtonFormBuilder.vue?vue&type=script&lang=ts"

import "./FloatingButtonFormBuilder.vue?vue&type=style&index=0&id=35c39f2d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35c39f2d"

export default script